
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import { REQUEST_API_KEY, RESET_API_KEY } from 'modules/Api/constants';
import styled from 'styled-components';
import {BrowserRouter as Router, Route, Switch, withRouter, Link } from 'react-router-dom';
import { selectApiKey } from 'modules/Api/selectors';
import {Card} from '../../../components/Card';
import {Loader} from '../../../components/Loader';
import { Button } from '../../../components/Buttons';
import { BaseComponent } from '../../../components/BaseComponent';
import { selectWork } from '../../../modules/Api/selectors';
import { REQUEST_PASSWORD_RESET, REQUEST_PASSWORD_SET } from '../../../modules/Api/constants';
import { FormField, FormFields } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { Well } from '../../../components/Well';
import { Title } from '../../../components/Title';

const baseState = {
  password:'',
  password2: '',
  error : null
}

/* eslint-disable react/prefer-stateless-function */
class PasswordSetComp extends BaseComponent {

  constructor(props) {
    super(props, {...baseState});
  }

  resetSelf(){
    this.setState( { ...baseState});
    this.props.history.push("/");
  }

  onInputChange(e){
    this.updateState(e.target.name, e.target.value);
  }

  render(){

    if(this.props.loading) return <Loader onCard/>

    if(this.state.setPasswordComplete) return this.renderSetComplete();

    let footer = <>
      <Button onClick={this.resetSelf.bind(this)}>{this.lbl('back')}</Button>
      <Button isPrimary onClick={ this.submitNewPassword.bind(this)}>{this.lbl('save')}</Button>
    </>;

    return  <div center>
        <Card small footer={footer}>
    {this.state.passwordSetError ? <div className='well error'> {this.lbl(this.state.passwordSetError)} </div> : ''}
    <Title main={this.lbl('password.reset.title')}/>
    <Well>

        {this.lbl('password.set.instruction')}
    </Well>
      <form >
          <FormFields vertical narrow>
        <FormField vertical label={this.lbl('password')}>
          <Input
            className="input-element"
            id="password"
            type="password"
            name="password"
            value={this.state.password}
            onChange={this.onInputChange.bind(this)}
          />
        </FormField>

        <FormField label={this.lbl('password2')}>
          <Input
            className="input-element"
            id="password2"
            type="password"
            name="password2"
            value={this.state.password2}
            onChange={this.onInputChange.bind(this)}
          />
        </FormField>
        </FormFields>
      </form>
    </Card>
    </div>
  }

  renderSetComplete(){
    return <div center>
    <Card small     headerTitle={this.lbl('password.set.complete.header')} footer={<Button isPrimary onClick={this.resetSelf.bind(this)}>Login</Button>}>
      {this.lbl('password.set.complete.body')}
    </Card> </div>
  }

  submitNewPassword(){

    if(this.state.password != this.state.password2) {
      this.updateState('passwordSetError', 'password.set.error.match');
      return;
    }

    this.updateState({passwordSetError: false, setPasswordComplete : false});

    this.props.passwordSet(this.state.password, this.props.code, (result) => {
      if(result.result) {
        this.updateState('setPasswordComplete', true);
      } else {
        this.updateState('passwordSetError', 'error');
      }
    });

  }
}

PasswordSetComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({
  apiKey : selectApiKey(),
  loading : selectWork(REQUEST_PASSWORD_SET)
});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    passwordSet(password, code, callback){
      dispatch({
        type : REQUEST_PASSWORD_SET,
        password, code, callback
      })
    }
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const PasswordSet = compose(
  withRouter,
  withConnect
)(PasswordSetComp);
